/**
 * @author Kelnik
 *
 * FullText - раскрытие текста
 */

import Observer from 'common/scripts/observer';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class FullText {
    constructor(options) {
        this.element = options.element;
        this.openClass = 'is-open';
        this.duration = 400;
    }

    init() {
        this._getElements();
        this._getHeight();
        this._bindEvents();
        this._subscribes();
    }

    _getElements() {
        this.target = this.element.querySelector('.j-show-full-text');
        this.button = this.element.querySelector('.j-show-full-btn');
        this.buttonText = this.element.querySelector('.j-show-full-btn-text');
        this.fullContainer = this.element.classList.contains('j-show-full__container');
        this.initialText = this.button.getAttribute('data-init-text');
        this.openText = this.button.getAttribute('data-open-text');
        this.isOpen = false;
    }

    _getHeight() {
        this.elementHeight = this.element.offsetHeight;
        this.fullHeight = this.target.scrollHeight;

        if (this.isOpen) {
            this.target.style.removeProperty('height');
            this.initialHeight = this.target.offsetHeight;
            this.target.style.setProperty('height', 'auto');
        } else {
            this.initialHeight = this.target.offsetHeight;
        }
    }

    _bindEvents() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this._onResize.bind(this));
        });

        this.button.addEventListener('click', this._showHandler.bind(this));
    }

    _subscribes() {
        observer.subscribe('closeAllFullText', (container) => {
            const instances = [...container.querySelectorAll('.j-show-full')];

            instances.forEach(() => {
                this._showInitial();
                this._initialButtonText();
            });
        });
    }

    _setOpen() {
        this.isOpen = this.target.classList.contains(this.openClass);
    }

    _onResize() {
        this._getHeight();
    }

    _showHandler() {
        event.preventDefault();

        /* eslint-disable no-unused-expressions */
        this.isOpen ? this._showInitial() : this._showFull();
        this.isOpen ? this._openButtonText() : this._initialButtonText();
        /* eslint-enable no-unused-expressions */
    }

    _showFull() {
        $(this.target)
            .animate({height: this.fullHeight}, this.duration, () => {
                this.target.style.setProperty('height', 'auto');
            })
            .addClass(this.openClass);

        if (this.fullContainer) {
            this.element.style.setProperty('height', 'auto');
        }

        observer.publish('openFullText');

        this._setOpen();
    }

    _showInitial() {
        $(this.target)
            .animate({height: this.initialHeight}, this.duration, () => {
                this.target.style.removeProperty('height');
            })
            .removeClass(this.openClass);

        if (this.fullContainer) {
            $(this.element).animate({height: 'auto'}, this.duration, () => {
                this.element.style.removeProperty('height');
            });
        }

        this._setOpen();
    }

    _openButtonText() {
        Utils.clearHtml(this.buttonText);
        Utils.insetContent(this.buttonText, this.openText);
    }

    _initialButtonText() {
        Utils.clearHtml(this.buttonText);
        Utils.insetContent(this.buttonText, this.initialText);
    }
}

export default FullText;
